import type { ComponentType } from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import {
  Dashboard as DashboardIcon,
  Inventory2 as InventoryIcon,
  History as HistoryIcon,
  PendingActions as RecogidaPendienteIcon,
  Person as PersonIcon,
  PhotoCamera as PhotoCameraIcon,
  LocalLaundryService as CleaningIcon,
  Group as GroupIcon,
  Payment as PaymentIcon,
} from '@mui/icons-material';
import {
  ADMIN_HOME_PATH,
  ADMIN_INVENTORY_PATH,
  ADMIN_INVENTORY_RECOGIDA_PENDIENTE_PATH,
} from '../routes/routePaths';

export interface SidebarNavItem {
  label: string;
  path: string;
  icon: ComponentType<SvgIconProps>;
  /** Optional count badge (e.g. queue length) */
  badge?: number;
}

/** Consignor (non-admin) — shared home at /home */
export const CONSIGNOR_NAV: SidebarNavItem[] = [
  { label: 'Inicio', path: '/home', icon: DashboardIcon },
  { label: 'Inventario', path: '/consignor/inventory', icon: InventoryIcon },
  { label: 'Ventas', path: '/consignor/sales', icon: HistoryIcon },
  { label: 'Perfil', path: '/consignor/profile', icon: PersonIcon },
];

/** Admin — home at /admin/home */
export const ADMIN_NAV: SidebarNavItem[] = [
  { label: 'Inicio', path: ADMIN_HOME_PATH, icon: DashboardIcon },
  { label: 'Inventario', path: ADMIN_INVENTORY_PATH, icon: InventoryIcon },
  {
    label: 'Recogida pendiente',
    path: ADMIN_INVENTORY_RECOGIDA_PENDIENTE_PATH,
    icon: RecogidaPendienteIcon,
  },
  { label: 'Ventas', path: '/admin/sales', icon: HistoryIcon },
  { label: 'Cola de fotos', path: '/admin/photo-queue', icon: PhotoCameraIcon },
  { label: 'Cola de limpieza', path: '/admin/cleaning-queue', icon: CleaningIcon },
  { label: 'Consignadores', path: '/admin/consignors', icon: GroupIcon },
  { label: 'Pagos', path: '/admin/payments', icon: PaymentIcon },
];

/** First N items shown in mobile bottom bar before "Más" (admin only uses overflow). */
export const MOBILE_BOTTOM_BAR_COUNT_ADMIN = 3;
